import type { ReactNode } from "react";

export interface ItemTitleProps {
  children: ReactNode;
}

export function ItemTitle({ children }: ItemTitleProps) {
  return (
    <h2 className="item--title" data-test-id="item-title">
      {children}
    </h2>
  );
}
